import { Component, type ErrorInfo, type ReactNode } from "react";

type Props = { children: ReactNode };
type State = { failed: boolean };

export default class ErrorBoundary extends Component<Props, State> {
  state: State = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("ui-render-failed", error, info.componentStack);
  }

  render() {
    if (this.state.failed) {
      return (
        <main style={{ padding: 32, color: "#234839", fontFamily: "system-ui" }}>
          <h1>页面暂时出了点问题</h1>
          <p>你的本地内容没有被删除。请刷新页面后重试。</p>
          <button type="button" onClick={() => window.location.reload()}>重新打开</button>
        </main>
      );
    }
    return this.props.children;
  }
}
